import * as React from 'react';
import { Card } from './Card';

export interface PromoCardProps {
  title: string;
  subtitle?: string;
  image_url?: string;
  children?: any;
}

export const PromoCard = (props: PromoCardProps) => (
  <Card>
    <div>
      <img
        className="w4 h4 br-100 dib bg-black-10"
        src={props.image_url || '/images/methods/add.png'}
        alt={props.title}
      />
    </div>
    <h4 className="ma0 mt3 lh-copy f3 tc black">{props.title}</h4>
    <p className="ma0 mt3 lh-copy f5 tc black-70">{props.subtitle}</p>
    {props.children}
  </Card>
);

export default PromoCard;
